<template>
  <span>
    <div
      class="flex-md-grow-1"
      v-for="chartInfo in chartsInfoResolved"
      :key="chartInfo.prop"
    >
      <v-card-charts-dashboard
        :title="chartInfo.title"
        :options="chartInfo.options"
        :chart-ref="chartInfo.key"
        :is-loading="chartInfo.loading"
      />

      <v-card class="elevation-0 my-3">
        <div v-if="isCompensacoesChart(chartInfo.key)" class="mt-5">
          <v-card-title class="mt-5">
            <h5>{{ chartInfo.title }} - Tabela</h5>
          </v-card-title>
          <div
            v-if="loadingPorChave[chartInfo.key]"
            class="d-flex align-center justify-center"
            style="height: 200px;"
          >
            <v-progress-circular indeterminate color="primary" size="32" />
          </div>
          <v-card-text v-else>
            <table-serv-comercial
              :dadosServicosMensais="getDadosMensais(chartInfo.key)"
              :traducaoIndicadores="traducaoIndicadores"
            />
          </v-card-text>
        </div>
      </v-card>
    </div>
  </span>
</template>

<script>
import Highcharts from "highcharts";
import HighchartsNoData from "highcharts/modules/no-data-to-display";
HighchartsNoData(Highcharts);

export default {
  name: "ChartsServComercial",
  components: {
    TableServComercial: () => import("./TableServComercial"),
    VCardChartsDashboard: () =>
      import("@/components/base/VCardChartsDashboard.vue"),
  },
  props: {
    dadosPsfp: {
      type: Object,
      default: () => ({ data: [] }),
    },
    dadosPatc: {
      type: Object,
      default: () => ({ data: [] }),
    },
    dadosRealizadosVsAtraso: {
      type: Object,
      default: () => ({ data: [] }),
    },
    dadosCompensacoesServicosConcluidasForaPrazo: {
      type: Object,
      default: () => ({ data: [] }),
    },
    dadosCompensacoesPagasUnidadesConsumidoras: {
      type: Object,
      default: () => ({ data: [] }),
    },
    dadosVolumeTotalCompensacoes: {
      type: Object,
      default: () => ({ data: [] }),
    },
    dadosQSPServicos: {
      type: Object,
      default: () => ({ data: [] }),
    },
    dadosPSAServicos: {
      type: Object,
      default: () => ({ data: [] }),
    },
    dadosPATServicos: {
      type: Object,
      default: () => ({ data: [] }),
    },
    loadingPorChave: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      traducaoIndicadores: {
        descricao: "Descrição do serviço prestado",
        valor_total: "Soma total de todos os meses do período",
      },
      chartsInfo: [
        {
          key: "psfp",
          title: "Percentual de Serviços Concluídos Fora do Prazo (PSFP)",
          tipo: "psfp",
          prop: "dadosPsfp",
          pointFormat: ".2f",
          suffix: "%",
        },
        {
          key: "patc",
          title: "Prazo Médio dos Serviços Concluídos em Atraso (PATC)",
          tipo: "patc",
          prop: "dadosPatc",
          pointFormat: ".2f",
        },
        {
          key: "realizadosVsAtraso",
          title: "Serviços Realizados vs. Realizados em Atraso",
          tipo: "realizados_vs_atraso",
          prop: "dadosRealizadosVsAtraso",
          pointFormat: ".2f",
          yAxisType: "logarithmic",
        },
        {
          key: "compensacoesServicosConcluidasForaPrazo",
          title:
            "Volume de Compensações Pagas por Serviços Concluídos em Atraso",
          tipo: "compensacoes",
          prop: "dadosCompensacoesServicosConcluidasForaPrazo",
          pointFormat: ".2f",
          suffix: " R$",
        },
        {
          key: "compensacoesPagasUnidadesConsumidoras",
          title: "Volume de Compensações Pagas por Unidade Consumidora",
          tipo: "compensacoes",
          prop: "dadosCompensacoesPagasUnidadesConsumidoras",
          pointFormat: ".3f",
          suffix: " R$",
        },
        {
          key: "volumeTotalCompensacoes",
          title: "Volume de Compensações Pagas",
          tipo: "volume_total_compensacoes",
          prop: "dadosVolumeTotalCompensacoes",
          pointFormat: ".2f",
          suffix: " R$",
        },
        {
          key: "qspServicos",
          title: "QSP - Quantidade de Serviços Pendentes Não Suspensos",
          tipo: "qsp",
          prop: "dadosQSPServicos",
          pointFormat: ".2f",
        },
        {
          key: "psaServicos",
          title: "PSA - % de Serviços Pendentes não Suspensos em Atraso",
          tipo: "psa",
          prop: "dadosPSAServicos",
          pointFormat: ".2f",
          suffix: "%",
        },
        {
          key: "patServicos",
          title: "PAT - Prazo Médio dos Serviços Pendentes em Atraso",
          tipo: "pat",
          prop: "dadosPATServicos",
          pointFormat: ".2f",
        },
      ],
    };
  },
  computed: {
    chartsInfoResolved() {
      return this.chartsInfo.map((ci) => {
        return {
          ...ci,
          options: this.getChartOptions(ci),
          loading: this.loadingPorChave[ci.key],
        };
      });
    },
  },
  methods: {
    isCompensacoesChart(chartKey) {
      return [
        "compensacoesServicosConcluidasForaPrazo",
        "compensacoesPagasUnidadesConsumidoras",
        "volumeTotalCompensacoes",
      ].includes(chartKey);
    },
    getDadosMensais(chartKey) {
      let dados = [];
      switch (chartKey) {
        case "compensacoesServicosConcluidasForaPrazo":
          dados = this.dadosCompensacoesServicosConcluidasForaPrazo.data;
          break;
        case "compensacoesPagasUnidadesConsumidoras":
          dados = this.dadosCompensacoesPagasUnidadesConsumidoras.data;
          break;
        case "volumeTotalCompensacoes":
          dados = this.dadosVolumeTotalCompensacoes.data;
          break;
        default:
          return [];
      }

      return this.ordenarDadosPorValorTotal(dados);
    },
    ordenarDadosPorValorTotal(dados) {
      if (!dados || !Array.isArray(dados)) {
        return [];
      }

      return [...dados].sort((a, b) => {
        const valorA = parseFloat(a.valor_total);
        const valorB = parseFloat(b.valor_total);
        return valorB - valorA;
      });
    },
    getChartOptions(chartInfo) {
      const sourceKey = chartInfo.prop;
      let chartData = this[sourceKey]?.data;

      if (this.isCompensacoesChart(chartInfo.key)) {
        chartData = this.ordenarDadosPorValorTotal(chartData);
      }

      const categories = chartData.map((item) => item.descricao);
      let dataField = chartInfo.tipo;
      if (this.isCompensacoesChart(chartInfo.key)) {
        dataField = "valor_total";
      }

      let series;
      series = [
        {
          name: chartInfo.tipo.toUpperCase(),
          data: chartData
            .map((item) => item[dataField])
            .filter((v) => v != null),
          type: "column",
          animation: false,
        },
      ];
      if (chartInfo.tipo === "realizados_vs_atraso") {
        series = [
          {
            name: "Realizados",
            data: chartData
              .map((item) => item.realizados)
              .filter((v) => v != null),
            type: "column",
            animation: false,
          },
          {
            name: "Realizados em Atraso",
            data: chartData
              .map((item) => item.realizados_em_atraso)
              .filter((v) => v != null),
            type: "column",
            animation: false,
          },
        ];
      }
      return {
        chart: {
          type: "column",
          scrollablePlotArea: {
            minWidth: series[0].data.length > 12 ? 11000 : null,
            scrollPositionX: 0,
          },
          animation: false,
        },
        credits: { enabled: false },
        title: { text: null },
        xAxis: {
          categories,
          crosshair: true,
        },
        yAxis: {
          type: chartInfo.yAxisType || "linear",
          max: chartInfo.yAxisMax,
          title: {
            text: null,
          },
        },
        tooltip: {
          shared: true,
          valueSuffix: chartInfo.suffix || "",
          outside: true,
          style: {
            zIndex: 99999,
          },
        },
        plotOptions: {
          series: {
            animation: false,
            dataLabels: {
              enabled: true,
              format: `{y:,.${chartInfo.pointFormat}}${chartInfo.suffix || ""}`,
            },
            grouping: true,
            pointPadding: 0.05,
          },
          column: { pointPlacement: 0 },
        },
        series,
        lang: {
          noData: "Sem dados para exibir",
        },
        noData: {
          style: {
            fontWeight: "bold",
            fontSize: "15px",
          },
        },
      };
    },
  },
};
</script>

<style></style>
